export const TRANSACTION_ENTRIES_TABS = {
  data: 'data',
  stream: 'stream',
  type: 'type',
  details: 'details',
} as const;
